import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from '@freelancer-os/ui/src/components/ui/sonner';
import { router } from './router';

// i18n must be imported before any component that uses useTranslation
import './i18n';

// Initialize theme (light/dark/system) from localStorage
import { initTheme } from './lib/theme';
initTheme();

// Make sure global styles from ui package are imported
import '@freelancer-os/ui/src/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="top-right" />
    </QueryClientProvider>
  );
}
